package ru.villawonka.app.platform.telegram.model

import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SafeAreaInset(
    @SerialName("top") val top: Int,
    @SerialName("bottom") val bottom: Int,
    @SerialName("left") val left: Int,
    @SerialName("right") val right: Int,
)

fun Int.toDp(density: Float): Dp = (this / density).dp
